import React from "react";
import {useSelector} from "react-redux";

const BRAND_ASSETS = {
    mark: "assets/brand/zofino-mark-192.png",
    en: "assets/brand/zofino-wordmark-en-768.png",
    fa: "assets/brand/zofino-wordmark-fa-768.png",
};

function BrandLogo({variant = "wordmark", className = "", alt = "Zofino", ...props}) {
    const language = useSelector((state) => state.app.config?.language) === "fa" ? "fa" : "en";
    const asset = variant === "mark" ? BRAND_ASSETS.mark : BRAND_ASSETS[language];

    return (
        <img
            src={`${process.env.PUBLIC_URL}/${asset}`}
            className={className}
            alt={alt}
            {...props}
        />
    );
}

export default BrandLogo;

